var exports = {
  "m": "Octicon__mPJavh",
};

module.exports = exports;
